import { createAction, props } from '@ngrx/store';
import { Group } from '@shared/models/group';

export const createCustomer = createAction(
  '[Customers] Create Customer',
  props<{ group: Partial<Group>; leadId?: number }>(),
);

export const createCustomerSuccess = createAction(
  '[Customers] Create Customer Success',
  props<{ group: Group; leadId?: number }>(),
);

export const createCustomerFailure = createAction('[Customers] Create Customer Failure', props<{ error: any }>());
